document.querySelectorAll('.player-container').forEach(function (container) {
  const track = container.querySelector('audio');
  const controlBtn = container.querySelector('.play-pause');

  controlBtn.addEventListener('click', function () {
    // Pausa tutti gli altri audio
    document.querySelectorAll('audio').forEach(function (audio) {
      if (audio !== track) {
        audio.pause();
        audio.closest('.player-container').querySelector('.play-pause').className = 'play-pause play';
      }
    });

    // Alterna Play/Pause per il pulsante corrente
    if (track.paused) {
      track.play();
      controlBtn.className = 'play-pause pause';
    } else {
      track.pause();
      controlBtn.className = 'play-pause play';
    }
  });

  // Reset del pulsante quando l'audio termina
  track.addEventListener('ended', function () {
    controlBtn.className = 'play-pause play';
  });
});











const audio = document.getElementById("audio-player");
const playPauseBtn = document.getElementById("play-pause-btn");
const playPauseIcon = document.getElementById("play-pause-icon");

playPauseBtn.addEventListener("click", () => {
  if (audio.paused) {
    audio.play();
    playPauseIcon.src = "https://cdn.shopify.com/s/files/1/0921/8270/8563/files/pause_bianco_full.png?v=1736087260"; // Cambia all'icona di pausa
  } else {
    audio.pause();
    playPauseIcon.src = "https://cdn.shopify.com/s/files/1/0921/8270/8563/files/play_bianco_full.png?v=1736087261"; // Cambia all'icona di play
  }
});

// Sincronizza il tempo e il progresso
audio.addEventListener("timeupdate", () => {
  const progressBar = document.getElementById("progress-bar");
  const currentTimeElem = document.getElementById("current-time");
  const durationElem = document.getElementById("duration");

  progressBar.value = (audio.currentTime / audio.duration) * 100 || 0;
  currentTimeElem.textContent = formatTime(audio.currentTime);
  durationElem.textContent = formatTime(audio.duration || 0);
});

// Funzione per formattare il tempo in MM:SS
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
}

// Cambia il tempo tramite la barra di progresso
document.getElementById("progress-bar").addEventListener("input", (e) => {
  const seekTime = (e.target.value / 100) * audio.duration;
  audio.currentTime = seekTime;
});





document.addEventListener("DOMContentLoaded", function () {
    const widget = document.querySelector("div.widget-6695.wsg-follow-left");
    if (widget) {
        widget.remove();
    }
});

